import { Pipe, PipeTransform } from '@angular/core';
import { QRCategoryItemModel } from '@cue/api';

@Pipe({
  name: 'categoryListCategoriesOnly',
  standalone: true,
})
export class CategoryListCategoriesOnlyPipe implements PipeTransform {
  transform(listData: QRCategoryItemModel[]): QRCategoryItemModel[] {
    if (listData) {
      return listData.filter((x) => !x.resourceTypeId);
    }
    return [];
  }
}
